/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * Utility to change attributes of an object
 */
export class ObjectManipulator {
    /**
     * change a list of attributes for an object
     * @param obj the object
     * @param list list of attributes
     */
    static setAttributeList(obj, list) {
        list.forEach((e) => { this.setAttribute(obj, e.name, e.value, e.type); });
    }
    /**
     * changes an attribute for an object
     * @param obj the object
     * @param name the name of the attribut (e.g. position)
     * @param value the value to set / change
     * @param type the type of value ('vector' or any other)
     */
    static setAttribute(obj, name, value, type) {
        switch (type.toLowerCase()) {
            case 'vector':
            case 'vector2':
            case 'vector3':
            case 'vector4':
            case 'color':
            case 'quaternion':
                // tslint:disable-next-line:no-any
                obj[name].fromArray(value);
                break;
            default:
                // tslint:disable-next-line:no-any
                obj[name] = value;
        }
    }
}
//# sourceMappingURL=ObjectManipulator.js.map